import styled from 'styled-components';
import config from '../../../config';
const { desktopMinWidth } = config;

export const PageLayout = styled.div`
  width: auto;
  height: 100vh;
  display: flex;
  align-items: center;
  text-align: center;
`;

export const GridLayout = styled.div`
  height: 100%;
  width: 100%;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    width: 1168px;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(8, 132px);
    grid-column-gap: 16px;
    margin: 0 auto;
    padding: 0 16px;
    text-align: left;
  }
`;

export const LeftSideLayout = styled.div`
  padding: 0 24px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    padding: 0;
    grid-column: 1 / 4;
    justify-items: start;
  }
`;

/**
 * Coinplug logo container
 */
export const LogoContainer = styled.div`
  margin-top: 56px;
`;

/**
 * Coinplug logo style
 */
export const Logo = styled.img`
  height: 24px;
`;

export const PageTitle = styled.div`
  /* var(--font) 는 public/index.html 에 정의되어 있음 */
  font-family: var(--font);
  font-size: 40px;
  font-weight: 400;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
  margin-top: 108px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    font-size: 60px;
    grid-column: 2 / 8;
    margin-top: 120px;
  }
`;

export const Paragraph = styled.div`
  /* var(--font) 는 public/index.html 에 정의되어 있음 */
  font-family: var(--font);
  font-size: 16px;
  font-weight: 300;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 48px;
  display: none; /* 모바일에서는 보이지 않게 */
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    margin-top: 64px;
    font-size: 24px;
    display: block; /* pc 에서는 보이게 */
  }
`;

export const ResultBoxContainer = styled.div`
  margin-top: 48px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    margin: 0;
    grid-column: 5 / 9;
    height: 100vh;
    overflow-y: scroll;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 60px;
  margin-bottom: 32px;
  padding: 0px 32px;
  /* PC 화면 */
  @media only screen and (min-width: ${desktopMinWidth}) {
    margin-bottom: 48px;
  }
`;

export const VerifySignatureButton = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 4px;

  font-family: var(--font);
  font-weight: 400;
  font-size: 16px;

  cursor: pointer;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  color: #ffffff;
  background-color: #416AB1;
`;
